import { z } from 'zod';

const simResponseSchemas = {
  getAccountNumber: z.object({
    success: z.boolean(),
    data: z.string().transform((val) => Number(val)),
  }),
  getSimCardDetail: z.object({
    success: z.boolean(),
    data: z.object({
      id: z.number(),
      simnumber: z.string(),
      isEsim: z.number(),
      userid: z.number(),
      simtype: z.string(),
      simname: z.string(),
      imeinumber: z.string(),
      msisdn: z.string(),
      ultraplan: z.string(),
      username: z.string(),
      password: z.string(),
      tags: z.string(),
      ultraUserId: z.string(),
      activationdate: z.string(),
      msisdnUpdateDate: z.string(),
      planChangedDate: z.string(),
      billingstartdate: z.string(),
      billingenddate: z.string(),
      status: z.number(),
      QRActivationCode: z.string(),
      SMDPAddress: z.string(),
      ActivationCode: z.string(),
      PdfUrl: z.string(),
      datecreated: z.string(),
      datemodified: z.string(),
      planid: z.number(),
      reconnectTime: z.number().nullable(),
      title: z.string(),
      role: z.string(),
      offername: z.string(),
      productid: z.number().nullable(),
      offerId: z.number().nullable(),
      requestId: z.number(),
      newOfferName: z.string(),
      monthlyprice: z.number(),
      overageprice: z.number(),
      dataprice: z.number(),
      smsprice: z.number(),
      voiceprice: z.number(),
      duration: z.string(),
      unit: z.number(),
      category: z.string(),
      orderid: z.string(),
      ordernumber: z.string(),
      isILDEnabled: z.number(),
      isIREnabled: z.number(),
    }),
  }),
  getActivePortInRequestData: z.object({
    success: z.boolean(),
    data: z.null().or(
      z.object({
        title: z.string(),
        msisdn: z.string(),
        accountNumber: z.string(),
        accountPassword: z.string(),
        zipcode: z.string(),
        status: z.string(),
        reason: z.string(),
        datecreated: z.string(),
        datemodified: z.string(),
      })
    ),
  }),
  changePhoneNumber: z.object({
    success: z.boolean(),
    message: z.string(),
  }),
  getFilteredSims: z.object({
    success: z.boolean(),
    message: z.string(),
    total: z.number(),
    records: z.array(
      z.object({
        id: z.number(),
        userid: z.number(),
        planid: z.number(),
        simname: z.string(),
        simnumber: z.string(),
        isEsim: z.number(),
        ultraUserId: z.string(),
        tags: z.string(),
        activationdate: z.nullable(z.string()),
        zipcode: z.string(),
        ultraplan: z.string(),
        msisdn: z.string(),
        status: z.number(),
        simtype: z.string(),
        requestId: z.number(),
        datePlanChanged: z.nullable(z.string()),
        clientId: z.number(),
        clientname: z.string(),
        imeinumber: z.string(),
        datecreated: z.string(),
        portInRequestStatus: z.nullable(z.string()),
        portInStatusReason: z.nullable(z.string()),
        portInDateModified: z.nullable(z.string()),
        failedReason: z.string(),
        companyname: z.string(),
        ma_id: z.string(),
        StatusReason: z.nullable(z.string()),
      })
    ),
    counts: z.object({
      active: z.number(),
      inactive: z.number(),
      paused: z.number(),
      deactive: z.number(),
      activationInProgress: z.number(),
      availableeSim: z.number(),
      ordersCount: z.number(),
      eSIMOrdersCount: z.number(),
    }),
    limit: z.number(),
  }),
  updateSimName: z.object({
    success: z.boolean(),
    message: z.string(),
    results: z.array(z.number()),
  }),
  updateSimTags: z.object({
    success: z.boolean(),
    message: z.string(),
  }),
  getAllSimTags: z.object({
    success: z.boolean(),
    data: z.array(z.string()),
  }),
  deleteSims: z.object({
    success: z.boolean(),
    message: z.string(),
  }),
  generatePDF: z.object({
    success: z.boolean(),
    message: z.string(),
  }),
  getWifiCalling: z.object({
    success: z.boolean(),
    wifiCallingResp: z.object({
      enabled: z.boolean(),
      e911Address: z
        .object({
          street1: z.string(),
          street2: z.string().nullable(),
          city: z.string(),
          state: z.string(),
          zip: z.string(),
        })
        .optional(),
    }),
  }),
  enableWifiCalling: z.object({
    success: z.boolean(),
    message: z.string(),
  }),
  getActivityLogs: z.object({
    success: z.boolean(),
    data: z.array(
      z.object({
        id: z.number(),
        date: z.string(),
        text: z.string(),
      })
    ),
    count: z.number(),
  }),
  getESimsQuantity: z.object({
    success: z.boolean(),
    message: z.string(),
    isQuantityZero: z.boolean(),
    quantity: z.number(),
  }),
} as const;

export default simResponseSchemas;
